module.exports = __webpack_public_path__ + "static/media/banner_02.1b82a8e9.png";